module.exports = __webpack_public_path__ + "img/Avatar-15.4d679064.svg";